import type {
  DataProductEntity,
  DataProductEntitySpec,
  TypedEntityFilter,
} from '@ipen-portal/ipen-entity-model';
import type { FC } from 'react';

import { DataProductEntityFilter } from '@ipen-portal/ipen-entity-model';
import { useGetEntitiesByFilter } from '@ipen-portal/plugin-common-react';
import { useCallback } from 'react';

import { SelectFilter } from '../../../components/SelectFilter';
import { EntitySpecFilter } from '../../../utils/EntitySpecFilter';

type Props = {
  filter: TypedEntityFilter<DataProductEntity>;
};

const Filter: FC<Props> = ({ filter }) => {
  const { value: dataProducts } = useGetEntitiesByFilter(filter);

  const filterFactory = useCallback(
    (alignment: string) =>
      new EntitySpecFilter<DataProductEntitySpec>('alignment', alignment),
    [],
  );

  if (!dataProducts) {
    return null;
  }

  const items = [
    {
      label: 'source',
      value: 'source',
    },
    {
      label: 'aggregated',
      value: 'aggregated',
    },
    {
      label: 'consumer',
      value: 'consumer',
    },
  ];

  return (
    <SelectFilter
      filterFactory={filterFactory}
      items={items}
      label="Data Product Alignment"
      mobile={false}
      name="alignment"
    />
  );
};

export const DataProductAlignmentFilter: FC = () => (
  <Filter filter={DataProductEntityFilter} />
);
